<template>
  <nav class="navbar navbar-dark navbar-expand bg-dark sticky-top mr-auto">
    <a class="navbar-brand">
      <img src="../assets/logo.png" height="18" class="d-inline-block align-middle" alt="Life Plus">
      <small><small class="ml-2 align-bottom text-primary">beta</small></small>
    </a>

    <ul class="navbar-nav mr-auto text-primary ml-5 text-uppercase font-weight-bold">
      <li :class="'nav-item ' + (page === 'client' ? 'active' : '')">
        <a class="nav-link" @click="$emit('set-page', 'client')">Клиенты</a>
      </li>
      <li :class="'nav-item ' + (page === 'test' ? 'active' : '')">
        <a class="nav-link" @click="$emit('set-page', 'test')">Анализы</a>
      </li>
    </ul>

    <div class="d-inline">
      <img
        :src="avatar"
        height="24"
        class="rounded-circle mr-2"
        alt="*">
      <span class="align-middle text-secondary">{{ username }}</span>
      <a class="align-middle ml-3 text-primary" @click="logOut">Выход</a>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Header',

  props: ['page'],

  computed: {
    username: function () {
      const user = this.$store.state.user || {};
      const lastname = user.lastname || '';
      const firstname = user.firstname || '';

      return `${firstname} ${lastname.substr(0, 1)}.`;
    },

    avatar: function () {
      const user = this.$store.state.user || {};

      return user.image || null;
    },
  },

  methods: {
    async logOut() {
      try {
        await this.$store.dispatch('LOG_OUT');
      } catch (e) {
        this.error = e.message;
      }
    }
  },
};
</script>
